export const CALENDLY_URL = "https://calendly.com/liskovai/demo";
